import Main from "../pages/client";
import Balance from "../pages/client/balance";
import Login from "../pages/client/login";
import Chats from "../pages/client/chats";
import Profile from "../pages/client/profile";
import ResetPassword from "../pages/client/reset-password";
import ResetPasswordFinish from "../pages/client/reset-password-finish";
import WithdrawalRub from "../pages/client/withdrawal-rub";
import { AUTHED_ROUTES, GLOBAL_ROUTES, PUBLIC_ROUTES, ROUTES} from "./constants";
import React from "react";
import Account from "../pages/client/account";
import Transactions from "../pages/client/transactions";
import MainAdmin from "../pages/admin";
import SendMoneysSiteToUser from "../pages/client/send-moneys";
import Transaction from "../pages/client/transaction";
import CreatePost from "../pages/admin/create-post";
import Poster from "../pages/client/poster";
import Important from "../pages/client/important";
import Currencies from '../pages/client/currencies'
import Vacancy from '../pages/client/vacancy'
import UploadedDocuments from "../pages/admin/uploaded-documents";
import UploadedDocument from "../pages/client/uploaded-document";
import SubjectRights from "../pages/admin/subject-rights";
import ActionsCompoundSubjectRights from "../pages/admin/actions-compound-subject-rights";
import ActionsSubjectRights from "../pages/admin/actions-subject-rights";
import BillFill from "../pages/client/bill-fill";
import AdminAllBills from "../pages/admin/bills";
import Registry from '../pages/admin/registry'
import FinAnalitycsPage from "../pages/client/fin-analitycs";
import ProgrammsMinfin from "../pages/admin/programms-minfin";
export interface Routes {
    path: GLOBAL_ROUTES,
    Component: () => React.JSX.Element
}




export const publicRoutes: Routes[] = [
    {
        path: PUBLIC_ROUTES.LOGIN_ROUTE,
        Component: Login
    },
     {
        path: PUBLIC_ROUTES.MAIN_ROUTE,
        Component: Main 
    },
    {
        path: PUBLIC_ROUTES.RESET_PASSWORD_ROUTE,
        Component: ResetPassword
    },
    {
        path: PUBLIC_ROUTES.RESET_PASSWORD_FINAL_ROUTE,
        Component: ResetPasswordFinish
    },
    {
        path: PUBLIC_ROUTES.POSTER_ROUTE,
        Component: Poster
    },
    {
        path: PUBLIC_ROUTES.IMPORTANT_ROUTE,
        Component: Important
    },
    {
        path: PUBLIC_ROUTES.CURRENCIES_ROUTE,
        Component: Currencies
    },
    {
        path: PUBLIC_ROUTES.VACANCY_ROUTE,
        Component: Vacancy
    }
]


export const authedRoutes: Routes[] = [
    {
        path: AUTHED_ROUTES.ACCOUNT_ROUTE,
        Component: Account
    },
    {
        path: AUTHED_ROUTES.ADD_BALANCE_RUB_ROUTE,
        Component: Balance 
    },
    {
        path: AUTHED_ROUTES.CHATS_ROUTE,
        Component: Chats 
    },
    {
        path: AUTHED_ROUTES.PROFILE_ROUTE,
        Component: Profile 
    },
    {
        path: AUTHED_ROUTES.TRANSACTIONS_ROUTE,
        Component: Transactions
    },
    {
        path: AUTHED_ROUTES.TRANSACTION_ROUTE,
        Component: Transaction
    },
    {
        path: AUTHED_ROUTES.SEND_MONEYS_SITE_ROUTE,
        Component: SendMoneysSiteToUser
    },
    {
        path: AUTHED_ROUTES.WITHDRAWAL_RUB_ROUTE,
        Component: WithdrawalRub 
    },
    {
        path: AUTHED_ROUTES.ADMIN_ROUTE,
        Component: MainAdmin
    },
    {
        path: AUTHED_ROUTES.CREATE_POST_ROUTE,
        Component: CreatePost
    },
    {
        path: AUTHED_ROUTES.UPLOADED_DOCUMENTS_ROUTE,
        Component: UploadedDocuments
    },
    {
        path: AUTHED_ROUTES.UPLOADED_DOCUMENT_ROUTE,
        Component: UploadedDocument
    },
    {
        path: AUTHED_ROUTES.SUBJECT_RIGHTS,
        Component: SubjectRights
    },
    {
        path: AUTHED_ROUTES.SUBJECT_RIGHTS_ACTIONS,
        Component: ActionsSubjectRights
    },
    {
        path: AUTHED_ROUTES.COMPOUND_SUBJECT_RIGHTS_ACTIONS,
        Component: ActionsCompoundSubjectRights
    },
    {
        path: AUTHED_ROUTES.BILL_FILL,
        Component: BillFill
    },
    {
        path: AUTHED_ROUTES.ADMIN_ALL_BILLS,
        Component: AdminAllBills
    },
    {
        path: AUTHED_ROUTES.REGISTRY_ROUTE,
        Component: Registry
    },
    {
        path: AUTHED_ROUTES.FIN_ANALITYCS_ROUTE,
        Component: FinAnalitycsPage
    },
    {
        path: AUTHED_ROUTES.PROGRAMMS_MINFIN_ROUTE,
        Component: ProgrammsMinfin
    }
]
